<template>
  <div class="vertical-stepper">
    <ul id="stepper-ul">
      <li
        v-for="(item, index) in tocList"
        :id="'stepper-li-' + index"
        :key="index"
        v-b-tooltip.bottom.hover
        :class="{ 'hover-effect': shouldApplyHoverEffect(invalid, index) }"
        :title="getTooltipTitle(invalid, index)"
      >
        <a
          :class="[
            item.class,
            {
              'disabled-stepper': isDisabledStepper(invalid, index, item.class),
            },
          ]"
          @click="clickedItem(index)"
        >
          <span v-if="item.title"> {{ resource[item.title] }}</span>
          <span v-else> {{ item.name }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TocMenu',

  props: {
    tocList: {
      type: Array,
      default: () => [],
    },
    inComingIndex: {
      type: Number,
      default: 0,
    },
    invalid: {
      type: Boolean,
      default: true,
    },
    interview: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      previousIndex: this.inComingIndex,
      pageType: '',
      selectboxError: false,
    };
  },

  created() {
    this.pageType = this.$route.path.includes('/question-generator') ? 'question' : 'interview';
  },

  computed: {
    getCustomRulesIgnoreMessage() {
      if (this.pageType === 'question') {
        return !(this.inComingIndex === 1);
      }
      if (this.pageType === 'interview') {
        return !(this.inComingIndex === 2);
      }
      return false;
    },
  },

  watch: {
    inComingIndex(val) {
      this.previousIndex = val;
    },
    interview: {
      handler(newVal) {
        this.setSelectboxError(newVal.questions);
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    clickedItem(index) {
      if (this.previousIndex !== index) {
        this.$emit('stepperItem', index);
      }
      // this.$emit("stepperItem", index);
    },
    setSelectboxError(questions) {
      if (this.interview.type === 1) {
        this.selectboxError = questions.some((el) => el.thinkTime === null || el.timeLimit === null);
      }
    },
    isDisabledStepper(invalid, index, itemClass) {
      return (
        (invalid && index !== 0 && itemClass !== 'visited')
        || (this.interview.type === 1 && index === 3 && this.selectboxError)
      );
    },
    getTooltipTitle(invalid, index) {
      return (invalid && index !== 0) || (this.interview.type === 1 && index === 3 && this.selectboxError)
        ? this.resource['jobList.TOC.Required']
        : '';
    },
    shouldApplyHoverEffect(invalid, index) {
      return !(invalid && index !== 0) && !(this.interview.type === 1 && index === 3 && this.selectboxError);
    },
  },
};
</script>

<style lang="scss">
@import '~@/style/starter.scss';

$primary: #FF8D06;
$muted:   #e6e6e6;
$text:    #353535;

$bullet-w: 28px;
$bullet-h: 28px;
$line: 1px;

$svg-default: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'><g clip-path='url(%23clip0)'><path d='M12.5 0C5.876 0 0.5 5.376 0.5 12C0.5 18.624 5.876 24 12.5 24C19.124 24 24.5 18.624 24.5 12C24.5 5.376 19.124 0 12.5 0ZM12.5 21.6C7.196 21.6 2.9 17.304 2.9 12C2.9 6.696 7.196 2.4 12.5 2.4C17.804 2.4 22.1 6.696 22.1 12C22.1 17.304 17.804 21.6 12.5 21.6Z' fill='%23C3C3C3'/></g><defs><clipPath id='clip0'><rect width='24' height='24' fill='white' transform='translate(0.5)'/></clipPath></defs></svg>");
$svg-completed: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><g clip-path='url(%23clip1)'><path d='M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 21.6C6.708 21.6 2.4 17.292 2.4 12C2.4 6.708 6.708 2.4 12 2.4C17.292 2.4 21.6 6.708 21.6 12C21.6 17.292 17.292 21.6 12 21.6ZM17.508 6.696L9.6 14.604L6.492 11.508L4.8 13.2L9.6 18L19.2 8.4L17.508 6.696Z' fill='%23FF8D06'/></g><defs><clipPath id='clip1'><rect width='24' height='24' fill='white'/></clipPath></defs></svg>");
$svg-active: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='25' height='24' viewBox='0 0 25 24' fill='none'><g clip-path='url(%23clip2)'><path d='M12.5 0C5.876 0 0.5 5.376 0.5 12C0.5 18.624 5.876 24 12.5 24C19.124 24 24.5 18.624 24.5 12C24.5 5.376 19.124 0 12.5 0ZM12.5 21.6C7.196 21.6 2.9 17.304 2.9 12C2.9 6.696 7.196 2.4 12.5 2.4C17.804 2.4 22.1 6.696 22.1 12C22.1 17.304 17.804 21.6 12.5 21.6Z' fill='%23FF8D06'/><path d='M12.5 18C15.8137 18 18.5 15.3137 18.5 12C18.5 8.68629 15.8137 6 12.5 6C9.18629 6 6.5 8.68629 6.5 12C6.5 15.3137 9.18629 18 12.5 18Z' fill='%23FF8D06'/></g><defs><clipPath id='clip2'><rect width='24' height='24' fill='white' transform='translate(0.5)'/></clipPath></defs></svg>");
$svg-default-mobile: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g clip-path="url(%23clip0_13831_13247)"><path d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8 14.4C4.464 14.4 1.6 11.536 1.6 8C1.6 4.464 4.464 1.6 8 1.6C11.536 1.6 14.4 4.464 14.4 8C14.4 11.536 11.536 14.4 8 14.4Z" fill="%23C3C3C3"/></g><defs><clipPath id="clip0_13831_13247"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>');
$svg-completed-mobile: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g clip-path="url(%23clip0_13831_13455)"><path d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8 14.4C4.472 14.4 1.6 11.528 1.6 8C1.6 4.472 4.472 1.6 8 1.6C11.528 1.6 14.4 4.472 14.4 8C14.4 11.528 11.528 14.4 8 14.4ZM11.672 4.464L6.4 9.736L4.328 7.672L3.2 8.8L6.4 12L12.8 5.6L11.672 4.464Z" fill="%23FF8D06"/></g><defs><clipPath id="clip0_13831_13455"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>');
$svg-active-mobile: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g clip-path="url(%23clip0_13831_13912)"><path d="M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8 14.4C4.464 14.4 1.6 11.536 1.6 8C1.6 4.464 4.464 1.6 8 1.6C11.536 1.6 14.4 4.464 14.4 8C14.4 11.536 11.536 14.4 8 14.4Z" fill="%23FF8D06"/><path d="M8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z" fill="%23FF8D06"/></g><defs><clipPath id="clip0_13831_13912"><rect width="16" height="16" fill="white"/></clipPath></defs></svg>');

.vertical-stepper {
  position: static;
  margin-bottom: 24px;

  @media only screen and (max-width: map-get($grid-breakpoints, "md")) {
    margin-top: 16px;
  }

  ul {
    padding: 0; margin: 0;
    list-style: none;
    display: flex; align-items: flex-start;
  }

  ul > li {
    position: relative;
    flex: 1 1 0;
    text-align: center;
    padding: 0 8px;

    &::before {
      content: '';
      position: absolute;
      top: ($bullet-h / 2) - ($line / 2);
      left: calc(-50% + 12px);
      width: calc(100% - 24px);
      height: $line;
      background: #c3c3c3;
      z-index: 0;

      @include media-breakpoint-down(md) {
        top: 7px;
      }
    }
    &:first-child::before { display: none; }

    a {
      position: relative;
      display: block;
      padding-top: $bullet-h + 10px;
      color: #C3C3C3;
      text-decoration: none;
      cursor: pointer;
      font-size: 14px !important;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: $bullet-w;
        height: $bullet-h;
        background-image: $svg-default;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        z-index: 1;

        @include media-breakpoint-down(md) {
          width: 16px;
          height: 16px;
          background-image: $svg-default-mobile;
        }
      }
    }
  }

  a.active {
    color: #333; font-weight: 500;
    &::after {
      background-image: $svg-active;
      @include media-breakpoint-down(md) {
        background-image: $svg-active-mobile;
      }
    }
  }
  li:has(> a.active)::before { background: $primary; }

  a.visited {
    color: #333;
    font-weight: 400;
    &::after {
      background-image: $svg-completed;

      @include media-breakpoint-down(md) {
        background-image: $svg-completed-mobile;
      }
    }
  }
  li:has(> a.visited)::before { background: $primary; }

  .disabled-stepper {
    pointer-events: none; cursor: not-allowed;

    li:has(> a.visited)::before,
    li:has(> a.active)::before { background: $muted; }

    a.visited::after {
      background-image: $svg-default;

      @include media-breakpoint-down(md) {
        background-image: $svg-default-mobile;
      }
    }
    a.active::after  {
      background-image: $svg-default;

      @include media-breakpoint-down(md) {
        background-image: $svg-default-mobile;
      }
    }
  }
}
</style>
